import React from 'react'
import AbsolutePageTemplate from '../../../components/templates/AbsolutePageTemplate'
import ServiceOrdersLoader from './_load/ServiceOrderLoader'
import PageContent from './PageContent'
import PageHeader from './_shared/PageHeader'
import ChildrenServiceOrdersLoader from './_load/ChildrenServiceOrdersLoader'

const TemplateSannyGoldPdfPage = ({ id, templateId }) => {
  return (
    <AbsolutePageTemplate>
      <ServiceOrdersLoader id={parseInt(id)}>
        <ChildrenServiceOrdersLoader id={parseInt(id)}>
          <PageHeader templateId={parseInt(templateId)} />
          <PageContent />
        </ChildrenServiceOrdersLoader>
      </ServiceOrdersLoader>
    </AbsolutePageTemplate>
  )
}

export default TemplateSannyGoldPdfPage
